import { isConseilMenuEnabled } from '@/components/TopBar/conseilMenuAccess'

// Garde de l'ecran « Conseil ». L'entree de menu est cachee pour les comptes Pro, mais
// une URL tapee a la main doit etre refusee de la meme facon : un compte Pro est renvoye
// vers son abonnement, qui gere son cas.
//
// IMPORTANT (Vue Router 4) : NE PAS declarer le parametre `next`. Des qu'un garde a une
// arite >= 3, Vue Router attend un appel explicite a next() et ignore la valeur de retour,
// ce qui bloque la navigation a l'infini. On reste donc en arite 0, comme
// investorBeforeEnter.
//
// A la difference de la garde EDL, on NE verifie PAS l'abonnement ici : l'ecran est fait
// pour etre vu par les non-abonnes, c'est lui qui presente l'offre.
export const conseilBeforeEnter = () => {
  if (!isConseilMenuEnabled()) {
    return '/my-subscription'
  }

  return true
}
